
// Extrahiere alle UTM-Parameter und den topic-Parameter aus der URL
function getUTMParameters() {
    const searchParams = new URLSearchParams(window.location.search);
    const utmParams = {};

    for (const [key, value] of searchParams.entries()) {
        if (
            key.startsWith('utm_') ||
            key === 'topic' ||
            key === 'gclid' ||
            key === 'fbclid' ||
            key === 'clickid' ||
            key === 'msclkid' ||
            key === 'ttclid'          
        ) {
            utmParams[key] = value;
        }
    }
    return utmParams;
}

// Aktualisiere den Local Storage, indem vorhandene UTM-Parameter beibehalten und neue hinzugefügt werden
function updateUTMLocalStorage() {
    const urlUTMParams = getUTMParameters();

    // Falls keine UTM-Parameter in der URL vorhanden sind, muss nichts aktualisiert werden
    if (Object.keys(urlUTMParams).length === 0) {
        return;
    }

    // Hole vorhandene UTM-Parameter aus dem Local Storage (falls vorhanden)
    let storedUTMParams = {};
    const stored = localStorage.getItem('utm-params');
    if (stored) {
        try {
            storedUTMParams = JSON.parse(stored);
        } catch (e) {
            // Falls das Parsing fehlschlägt, initialisieren wir ein leeres Objekt
            storedUTMParams = {};
        }
    }

    // Merge: Neue URL-Parameter überschreiben nicht die bestehenden, sondern werden ergänzt.
    const mergedUTMParams = { ...storedUTMParams, ...urlUTMParams };

    // Aktualisiere den Local Storage
    localStorage.setItem('utm-params', JSON.stringify(mergedUTMParams));
}

// Beim Laden der Seite die Funktion ausführen
document.addEventListener('DOMContentLoaded', updateUTMLocalStorage);
  